module.exports = __webpack_public_path__ + "media/Bewajah_OST.089de8d2.mp3";